export default __webpack_public_path__ + "static/media/desk_glowboo.fa1c049b.png";